import React from 'react';
import { ContentSection, SectionTitle, Grid, InfoCard, InfoLabel, InfoValue } from '../common/StyledComponents';

const PolicyInformation = ({ policyData }) => (
  <ContentSection>
    <SectionTitle>Policy Information</SectionTitle>
    <Grid>
      <InfoCard>
        <InfoLabel>Policy Number</InfoLabel>
        <InfoValue>{policyData.policyNumber}</InfoValue>
      </InfoCard>
      <InfoCard>
        <InfoLabel>Type of Coverage</InfoLabel>
        <InfoValue>{policyData.coverage}</InfoValue>
      </InfoCard>
      <InfoCard>
        <InfoLabel>Policy Start Date</InfoLabel>
        <InfoValue>{policyData.startDate}</InfoValue>
      </InfoCard>
      <InfoCard>
        <InfoLabel>Policy Renewal Date</InfoLabel>
        <InfoValue>{policyData.renewalDate}</InfoValue>
      </InfoCard>
    </Grid>
  </ContentSection>
);

export default PolicyInformation; 